import React from "react";

const TelegramSvg = () => {
	return (
		<svg
			width="19"
			height="17"
			viewBox="0 0 19 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>Telegram</title>
			<path
				d="M1.43018 7.64961C1.43018 7.64961 9.3558 4.27781 12.1045 3.09049C13.1583 2.61564 16.7316 1.09591 16.7316 1.09591C16.7316 1.09591 18.3808 0.431094 18.2434 2.04574C18.1976 2.71062 17.8311 5.03761 17.4646 7.55463C16.9148 11.1165 16.3193 15.0107 16.3193 15.0107C16.3193 15.0107 16.2276 16.103 15.4488 16.2929C14.67 16.4829 13.3872 15.6281 13.1583 15.4381C12.9749 15.2956 9.7223 13.1586 8.53114 12.1137C8.21044 11.8288 7.84394 11.259 8.57694 10.5941C10.2262 9.0269 12.1961 7.07978 13.3872 5.845C13.937 5.2751 14.4867 3.94534 12.1961 5.56005C8.94344 7.8871 5.73659 10.0716 5.73659 10.0716C5.73659 10.0716 5.00359 10.5466 3.62918 10.1191C2.25478 9.69178 0.651324 9.12182 0.651324 9.12182C0.651324 9.12182 -0.448113 8.40947 1.43018 7.64961Z"
				fill="white"
				className="fill-white dark:fill-darkCardBg"
			/>
		</svg>
	);
};

export default TelegramSvg;
